import { useEffect, useState } from 'react';

// 00:17:34 — restarts automatically when it reaches zero
const DURATION_SECONDS = 17 * 60 + 34;
const START = Date.now();

export function useCountdown() {
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(id);
  }, []);

  const elapsed = Math.floor((now - START) / 1000);
  const remaining = DURATION_SECONDS - (elapsed % (DURATION_SECONDS + 1));

  return {
    hours: Math.floor(remaining / 3600),
    minutes: Math.floor((remaining % 3600) / 60),
    seconds: remaining % 60,
  };
}
